import { LoadingOutlined } from '@ant-design/icons';
import { Result } from 'antd';
import React, { type ReactNode, useContext, useEffect, useRef } from 'react';
import { AuthContext } from '../../contexts/auth-context-provider';

const LogoutPage = (): ReactNode => {
  const { isAuthenticated, navigateToLogin, returnToApp, logout } = useContext(AuthContext);
  const logoutInitiated = useRef(false);

  useEffect(() => {
    if (isAuthenticated && !logoutInitiated.current) {
      logoutInitiated.current = true;
      logout().subscribe();
    }
  }, [isAuthenticated, logout]);

  if (!isAuthenticated) {
    return navigateToLogin;
  }

  if (!window.history.state?.usr?.local) {
    return returnToApp;
  }

  return <Result icon={<LoadingOutlined />} title="Logging you out..." />;
};

export default LogoutPage;
